import { ListChart, ListChartProps } from '../../../renderers/list-chart/list-chart.component';
import { EQUIPMENT_TIMERS_DURATION_BY_EQUIPMENT_LIST_CHART_DEFINITION } from './equipment-timers-duration-by-equipment-list-chart.definition';
import { EQUIPMENT_TIMERS_DURATION_BY_EQUIPMENT_LIST_CHART_MOCK_DATA } from './equipment-timers-duration-by-equipment-list-chart.mock';

export const EquipmentTimersDurationByEquipmentListChart = (props: ListChartProps) => <ListChart {...props} />;

EquipmentTimersDurationByEquipmentListChart.definition = EQUIPMENT_TIMERS_DURATION_BY_EQUIPMENT_LIST_CHART_DEFINITION;
EquipmentTimersDurationByEquipmentListChart.mockData = EQUIPMENT_TIMERS_DURATION_BY_EQUIPMENT_LIST_CHART_MOCK_DATA;
